export function addReportHeader(doc, {
    logo,
    logoType = 'PNG',
    logoX = 14,
    logoY = 10,
    logoWidth = 50,
    logoHeight = 25,
    companyName,
    companyAddress,
    reportTitle,
    reportParameters = [],
    reportParametersRight = [],
}) {
    if (logo) {
        doc.addImage(logo, logoType, logoX, logoY, logoWidth, logoHeight)
    }

    doc.setFontSize(16)
    doc.text(companyName || '', 70, 20)
    doc.setFontSize(14)
    doc.text(reportTitle || '', 70, 30)
    if (companyAddress) {
        doc.setFontSize(10)
        doc.text(companyAddress, 70, 35)
    }

    let y = 45
    const leftCount = reportParameters ? reportParameters.length : 0
    const rightCount = reportParametersRight ? reportParametersRight.length : 0
    const maxLines = Math.max(leftCount, rightCount)

    if (maxLines > 0) {
        doc.setFontSize(9)

        if (leftCount > 0) {
            reportParameters.forEach((param, index) => {
                const label = param.label || ''
                const value = param.value || ''
                doc.text(`${label}: ${value}`, 14, y + (index * 5))
            })
        }

        if (rightCount > 0) {
            const pageWidth = doc.internal.pageSize.width || doc.internal.pageSize.getWidth()
            const rightX = pageWidth - 14
            reportParametersRight.forEach((param, index) => {
                const label = param.label || ''
                const value = param.value || ''
                doc.text(`${label}: ${value}`, rightX, y + (index * 5), { align: 'right' })
            })
        }

        y += maxLines * 5
    }

    return y + 5
}

export function createReportFooterCallback(doc, { generatedBy, executionDateTime }) {
    return data => {
        const { pageSize } = doc.internal
        const pageHeight = pageSize.height || pageSize.getHeight()
        const pageWidth = pageSize.width || pageSize.getWidth()

        doc.setFontSize(8)
        doc.text(`Page ${data.pageNumber} of ${doc.internal.getNumberOfPages()}`, pageWidth / 2, pageHeight - 15, { align: 'center' })
        doc.text(`Execution Date: ${executionDateTime}`, 14, pageHeight - 10)
        doc.text(`Produced by: ${generatedBy}`, pageWidth - 14, pageHeight - 10, { align: 'right' })
    }
}
